import React from "react";
import "../../styles/Listing.css";
import ResidentialListing from "../../components/Checklists/Manitoba/ResidentialListing.js";

export default function Listing() {
  return (
    <div className="checklists flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 "></div>
      <ResidentialListing />
    </div>
  );
}
